/**
 * [pug template]
 */
<template lang="pug">
  .olst-field-modal
    .modal-parent(:id="name + '-modal'")
      transition(name="fade-mask")
        .modal-mask(@click="closeModal()", v-show="isDisplayed")
          .modal-wrapper
            transition(name="slide-modal")
              .modal-container(v-show="isDisplayed", @click.stop="() => {}")
                .modal-header
                  .modal-close(@click="closeModal()")
                .modal-content.clearfix
                  slot
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'modal',
  props: {
    name: {
      type: String,
      default: 'GalleryModal'
    },
    isDisplayed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
    }
  },
  components: {},
  methods: {
    /**
     * Demande la fermeture de la modale
     */
    closeModal: function () {
      this.$emit('close-modal')
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// GalleryModal.vue?a33a8ab4